import React from 'react'

const MoneyBackPolicy = () => {
  return (
    <>
        <div className="section py-5">
            <div className="container">
                <div className="text-center mb-4">
                    <img src='./assets/images/money.png' width='120' alt='' />
                    <h2>Simfly.biz 100% Money Back Guarantee</h2>
                </div>

                <div>
                    <p>Simfly.biz is the first and only travel e-Sim which guarantees you 100% money back if the e-Sim does not work in the Roaming Country it was bought for.</p>
                    <p>If Roaming e-Sims do not work when you reach your destination it can be really frustrating for you as you are left stranded with no internet for no fault of yours. Since, we have full faith in our product and we guarantee you we will refund 100% of the money paid by you if below conditions are met: </p>

                    <ol type='1'>
                            <li>The e-Sim was activated at the Roaming destination with activation visible on our platform. </li>

                            <li>There is usage less than 10% of the package, eg, if 5GB is bought, only 50MB was used.  </li>

                            <li>The refund request has been submitted maximum within 3 month of e-Sim purchase. </li>

                            <li>Any affiliate commissions will not be paid for theSe refunded e-Sims </li>
                    </ol>

                    <p>Kindly note the amount paid for will be refunded exclusive of all promotions and benefits, eg, if the e-Sim was bought for $5.00 under promotion (original price $10), only the amount paid will be refunded and not the actual plan value, in this example $5 will be refunded.</p>

                    <p>Process of Refund: </p>

                    <ol>
                        <li>Visit www.simfly.biz </li>

                        <li>Please put ‘Refund’ in chat window </li>

                        <li>Provide your email with which the e-Sim was bought </li>

                        <li>Provide the destination and plan detail</li>
                    </ol>

                    <p>Your money will be refunded maximum within 7 days if it meets all the above criterion.</p>

                    <p>We wish you have a pleasant and hassle-free experience using simfly.biz. </p>
                </div>
            </div>
        </div>
    </>
  )
}

export default MoneyBackPolicy